export enum AuthenticationType {
  UNSET_AUTHENTICATION_TYPE = 'UNSET_AUTHENTICATION_TYPE', // Do not use, needed because of proto3 limitations
  BASIC = 'BASIC',
  OAUTH2 = 'OAUTH2',
}
